var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-container"},[_c('div',{staticClass:"container"},[_c('h3',{staticClass:"banner-badge"},[_vm._v("시작하기")]),_c('h2',{staticClass:"banner-title"},[_vm._v("더 쉬운 중국 직구의 시작")]),_c('p',{staticClass:"banner-desc"},[_vm._v("고로켓고이 이용 방법을 안내합니다")])])])
}]

export { render, staticRenderFns }